export enum SystemDataFieldName {
    MapObjectName = "MapObjectName",
    MapObjectArea = "MapObjectArea",
    MapObjectLength = "MapObjectLength",
    Coordinates = "Coordinates",
    RouteTime = "RouteTime",
    QuantityOfModelsOnLine = "QuantityOfModelsOnLine",
    QuantityOfModelsInArea = "QuantityOfModelsInArea",
    RotationZOfModelsInArea = "RotationZOfModelsInArea",
    IconRotation = "IconRotation",
    ModelAltitude = "ModelAltitude",
    Relay = "Relay",
    RelayDay = "RelayDay",
    RelayStream = "RelayStream",
    RelayStage = "RelayStage"
}